import * as React from 'react';
import { DateTimeAccuracy, LocalizedDateTime } from "../LocalizedDateTime";

export const formatDateTime = value => value
    ? <LocalizedDateTime time={value} accuracy={DateTimeAccuracy.Minute} isTooltip={true} />
    : '-';

export const formatNull = value => value
    ? value
    : '-';

export const formatUndefined = value => value !== undefined
    ? value
    : '-';

export const formatCheck = value => value
    ? <i className="fas fa-check" style={{ color: 'green' }}></i>
    : <i className="fas fa-times" style={{ color: 'grey' }}></i>;
